import { Suspense, lazy } from "react";
import Background from "./Background";
import Navigation from "./Navigation";
import Hero from "./Hero";
import { usePageMeta } from "./page-meta";

const MeetDunc          = lazy(() => import("./MeetDunc"));
const Collection        = lazy(() => import("./Collection"));
const FormatsSection    = lazy(() => import("./FormatsSection"));
const TryDunc           = lazy(() => import("./TryDunc"));
const FlavourStories    = lazy(() => import("./FlavourStories"));
const KombuchaBenefits  = lazy(() => import("./KombuchaBenefits"));
const HowDuncMade       = lazy(() => import("./HowDuncMade"));
const WhyDunc           = lazy(() => import("./WhyDunc"));
const Philosophy        = lazy(() => import("./Philosophy"));
const Marquee           = lazy(() => import("./Marquee"));
const BrewNext          = lazy(() => import("./BrewNext"));
const DuncList          = lazy(() => import("./DuncList"));
const InstagramSection  = lazy(() => import("./InstagramSection"));
const MomentsTeaser     = lazy(() => import("./MomentsTeaser"));
const Contact           = lazy(() => import("./Contact"));
const Footer            = lazy(() => import("./Footer"));

export const DuncLanding = ({ scrollTo }) => {
  usePageMeta();

  return (
    <>
      <Navigation scrollTo={scrollTo} />
      <main className="relative min-h-screen overflow-hidden" data-testid="dunc-landing">
        <Background />
        <Hero scrollTo={scrollTo} />
        <Suspense fallback={<div style={{ minHeight: "60vh" }} aria-hidden="true" />}>
          <MeetDunc />
          <Collection />
          <FormatsSection />
          <TryDunc />
          <FlavourStories />
          <KombuchaBenefits />
          <HowDuncMade />
          <Marquee />
          <WhyDunc />
          <Philosophy />
          <BrewNext />
          <DuncList />
          <InstagramSection />
          <MomentsTeaser />
          <Contact />
          <Footer scrollTo={scrollTo} />
        </Suspense>
      </main>
    </>
  );
};

export default DuncLanding;
